import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";

const addressSlice = createSlice({
  name: "address",

  initialState: {
    addressData: [],
    isError: false,
  },

  reducers: {
    fetchAddressSuccess: (state, action) => {
      state.isError = false;
      state.addressData = action.payload;
    },
    fetchAddressFailure: (state) => {
      state.isError = true;
    },
    resetAddress: (state) => {
      state.addressData = [];
      state.isError = false;
    },
  },
});

export const { fetchAddressSuccess, fetchAddressFailure, resetAddress } =
  addressSlice.actions;

export const fetchAddress = (logout) => async (dispatch) => {
  try {
    const response = await axios.get(`${config.apiUrl}/address`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: config.token,
        Accept: "application/json",
      },
    });
    dispatch(fetchAddressSuccess(response.data.list));
  } catch (error) {
    dispatch(fetchAddressFailure());
    if (error.response && error.response.status === 401) {
      logout();
    }
  }
};

export default addressSlice.reducer;
